import { useEffect, useState } from 'react';
import { Pet, type PetDTO, type PetTemplateDTO } from '@/network/RestApi';
import { useCharacterStore } from '@/state/characterStore';
import { useUIStore } from '@/state/uiStore';
import { ui } from './theme';
import { CloseButton } from './CloseButton';

export function PetPanel() {
  const ch = useCharacterStore((s) => s.current);
  const close = () => useUIStore.getState().set('pet', false);
  const showToast = useUIStore((s) => s.showToast);
  const [pets, setPets] = useState<PetDTO[]>([]);
  const [templates, setTemplates] = useState<Record<number, PetTemplateDTO>>({});
  const [loading, setLoading] = useState(false);

  const refresh = () => {
    if (!ch) return;
    setLoading(true);
    Pet.list(ch.id)
      .then((r) => setPets(r.pets ?? []))
      .catch(() => setPets([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    Pet.templates()
      .then((r) => {
        const map: Record<number, PetTemplateDTO> = {};
        for (const t of r.templates ?? []) map[t.id] = t;
        setTemplates(map);
      })
      .catch(() => setTemplates({}));
  }, []);

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ch?.id]);

  const setActive = async (petId: number) => {
    if (!ch) return;
    try {
      await Pet.setActive(ch.id, { petId });
      showToast('Đã chọn pet đồng hành', 'info');
      refresh();
    } catch (e) {
      showToast((e as Error).message ?? 'Lỗi', 'error');
    }
  };

  return (
    <div style={{ position: 'absolute', top: 70, right: 10, width: 320, zIndex: 100, ...ui.panel }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
        <strong>Pet ({pets.length})</strong>
        <div style={{ display: 'flex', gap: 4 }}>
          <button style={ui.secondaryBtn} onClick={refresh}>↻</button>
          <CloseButton onClick={close} />
        </div>
      </div>

      {loading && <div style={{ opacity: 0.6, fontSize: 11 }}>Đang tải...</div>}

      {!loading && pets.length === 0 && (
        <div style={{ opacity: 0.6, fontSize: 11 }}>
          Chưa có pet. Mua hộp pet ở Shop và mở trong Túi đồ.
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        {pets.map((p) => {
          const tpl = templates[p.templateId];
          return (
            <div key={p.id} style={{
              display: 'flex', alignItems: 'center', gap: 8, padding: 6,
              background: '#0b1220',
              border: p.active ? '2px solid #ffeb3b' : '1px solid #324a5e',
              borderRadius: 4,
            }}>
              <div style={{
                width: 32, height: 32, background: '#000',
                border: '1px solid #324a5e',
                textAlign: 'center', lineHeight: '32px',
                color: '#9b59b6', fontWeight: 'bold', fontSize: 18,
              }}>P</div>
              <div style={{ flex: 1, fontSize: 11 }}>
                <div style={{ color: '#fff', fontWeight: 'bold' }}>
                  {p.nickname || tpl?.name || `Pet #${p.templateId}`}
                </div>
                <div style={{ opacity: 0.7 }}>
                  Tier {tpl?.tier ?? '?'} · Lv {p.level}
                  {p.active && <span style={{ color: '#ffeb3b', marginLeft: 6 }}>● Active</span>}
                </div>
              </div>
              <button
                style={{ ...ui.secondaryBtn, padding: '2px 8px', fontSize: 10 }}
                disabled={p.active}
                onClick={() => setActive(p.id)}
              >{p.active ? 'OK' : 'Active'}</button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
